import { createAsyncThunk, createSlice, original } from "@reduxjs/toolkit";
import { formatDataArrayAsMap } from "MainApp/features/Helpers/Map";
import { ACTION_FAILED, ACTION_IDLE, ACTION_PENDING, ACTION_SUCCEEDED } from "Store/constants";
import { SUGGESTED_USERS_PER_PAGE } from "./constants";
import { fetchSuggestedUsers, removeSuggestedUsers } from "./actions";
import toastr from 'toastr';

const cloneMap = (map) => (map instanceof Map ? new Map(map) : new Map());


export const FETCH_SUGGESTED_USERS = 'fetch/suggested/users';
export const REMOVE_SUGGESTED_USERS = 'remove/suggested/users';

export const fetchSuggestedUsersAction = createAsyncThunk(
    FETCH_SUGGESTED_USERS, 
    async (userInputData, thunkAPI) => await fetchSuggestedUsers(userInputData, thunkAPI)
)

export const removeSuggestedUsersAction = createAsyncThunk(
    REMOVE_SUGGESTED_USERS, 
    async (userInputData, thunkAPI) => await removeSuggestedUsers(userInputData, thunkAPI)
)

const initialState = {
    loading: ACTION_IDLE,
    error: null,
    data: new Map(),
    initData: new Map(),
    count: SUGGESTED_USERS_PER_PAGE,
    totalRecords: 0,
    pageNumber: 1,
    actionType: FETCH_SUGGESTED_USERS
}

const suggestedUsersSlice = createSlice({
    name: 'suggestedUsers',
    initialState,
    reducers: {
        resetSuggestedUsers(state){
            const currentInitData = original(state)?.initData;
            return {
                ...initialState,
                initData: currentInitData instanceof Map ? new Map(currentInitData) : new Map()
            };
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchSuggestedUsersAction.pending, (state, { payload }) => {
            state.loading = ACTION_PENDING;
            state.actionType = FETCH_SUGGESTED_USERS;
        })
        .addCase(fetchSuggestedUsersAction.fulfilled, (state, { payload }) => {
            state.loading = ACTION_SUCCEEDED;
            state.userInputData = payload.userInputData;
            state.actionType = FETCH_SUGGESTED_USERS;

            const originalState = original(state);
            let dataMap = cloneMap(originalState?.data);
            let initDataMap = cloneMap(originalState?.initData);

            //Clear the old data If call is initiated for page 1
            if(payload.userInputData.pageNumber === 1){
                dataMap = new Map();
            }

            if(payload.userInputData.pageNumber === 1 && !payload.userInputData.search){
                initDataMap = new Map();
            }

            const { userInputData, count, data, totalRecords } = payload;
            if(Array.isArray(data)){
                if(payload.userInputData.pageNumber === 1 && !payload.userInputData.search){
                    initDataMap = formatDataArrayAsMap('userId', [...data], initDataMap);
                }
                dataMap = formatDataArrayAsMap('userId', data, dataMap);
                state.count = count || state.count;
                state.totalRecords = totalRecords || state.totalRecords;
                state.pageNumber = userInputData.pageNumber;
            }

            state.data = dataMap;
            state.initData = initDataMap;
        })
        .addCase(fetchSuggestedUsersAction.rejected, (state, { payload }) => {
            state.loading = ACTION_FAILED;
            state.userInputData = payload.userInputData;
            state.actionType = FETCH_SUGGESTED_USERS;
        })
        .addCase(removeSuggestedUsersAction.pending, (state, { payload }) => {
            state.loading = ACTION_PENDING;
            state.actionType = REMOVE_SUGGESTED_USERS;
        })
        .addCase(removeSuggestedUsersAction.fulfilled, (state, { payload }) => {
            state.loading = ACTION_SUCCEEDED;
            state.userInputData = payload.userInputData;
            state.actionType = REMOVE_SUGGESTED_USERS;
            toastr.success(payload.message);
        })
        .addCase(removeSuggestedUsersAction.rejected, (state, { payload }) => {
            state.loading = ACTION_FAILED;
            state.userInputData = payload.userInputData;
            state.actionType = REMOVE_SUGGESTED_USERS;
        })
    }
});

export const { resetSuggestedUsers } = suggestedUsersSlice.actions;
export default suggestedUsersSlice.reducer;